function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

import _JSXStyle from "styled-jsx/style";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/* eslint-disable react/default-props-match-prop-types */
// Enable the above rule when the following is addressed https://github.com/yannickcr/eslint-plugin-react/issues/1674


import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from "./Icon";
import Modal from "./Modal";
import UncontrolledCarousel from "./UncontrolledCarousel";

var ImageCarousel =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ImageCarousel, _React$Component);

  var _super = _createSuper(ImageCarousel);

  function ImageCarousel(props) {
    var _this;

    _classCallCheck(this, ImageCarousel);

    _this = _super.call(this, props);

    _this.handleEscape = function (e) {
      if (e.key === 'Escape') {
        _this.props.toggle();
      }
    };

    _this.carousel =
    /*#__PURE__*/
    React.createRef();
    return _this;
  }

  _createClass(ImageCarousel, [{
    key: "goToIndex",
    value: function goToIndex(index) {
      if (index >= 0 && index < this.props.items.length && this.carousel && this.carousel.current) {
        this.carousel.current.goToIndex(index);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keyup', this.handleEscape);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          index = _this$props.index,
          isOpen = _this$props.isOpen;

      if (index !== prevProps.index || isOpen && isOpen !== prevProps.isOpen) {
        this.goToIndex(index);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keyup', this.handleEscape);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          defaultActiveIndex = _this$props2.defaultActiveIndex,
          autoPlay = _this$props2.autoPlay,
          controls = _this$props2.controls,
          index = _this$props2.index,
          items = _this$props2.items,
          indicators = _this$props2.indicators,
          interval = _this$props2.interval,
          slide = _this$props2.slide,
          toggle = _this$props2.toggle,
          props = _objectWithoutProperties(_this$props2, ["defaultActiveIndex", "autoPlay", "controls", "index", "items", "indicators", "interval", "slide", "toggle"]);

      return (
        /*#__PURE__*/
        React.createElement(Modal, _extends({
          external:
          /*#__PURE__*/
          React.createElement("div", {
            className: "jsx-2666442288" + " " + "h-100"
          },
          /*#__PURE__*/
          React.createElement(Icon, {
            name: "times",
            size: "2x",
            className: "text-white",
            style: {
              position: 'fixed',
              top: '2rem',
              right: '2rem',
              zIndex: 15000
            },
            onClick: toggle
          }),
          /*#__PURE__*/
          React.createElement(UncontrolledCarousel, {
            autoPlay: autoPlay,
            className: classnames('d-flex align-items-center h-100', 'carousel'),
            controls: controls,
            indicators: indicators,
            interval: autoPlay ? interval : 0,
            items: items,
            ref: this.carousel,
            slide: slide,
            defaultActiveIndex: index
          }),
          /*#__PURE__*/
          React.createElement(_JSXStyle, {
            id: "2666442288"
          }, ".carousel img{display:inline-block !important;max-height:100vh;max-width:100vw;width:auto !important;}.carousel .carousel-item{text-align:center !important;}"))
        }, props))
      );
    }
  }]);

  return ImageCarousel;
}(React.Component);

ImageCarousel.propTypes = _objectSpread({
  items: PropTypes.array.isRequired,
  indicators: PropTypes.bool,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  defaultActiveIndex: PropTypes.number,
  activeIndex: PropTypes.number,
  slide: PropTypes.bool
}, Modal.propTypes);
ImageCarousel.defaultProps = {
  autoPlay: false,
  backdrop: true,
  fade: false,
  items: [],
  slide: false,
  toggle: function toggle() {}
};
ImageCarousel.displayName = "ImageCarousel";
export { ImageCarousel as default };